import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-snackbar-with-cc',
    templateUrl: './snackbar-with-cc.component.html',
    styleUrls: ['./snackbar-with-cc.component.scss']
})
export class SnackbarWithCcComponent {

    durationInSeconds = 5;

    constructor(private toastr: ToastrService) {}

    openSnackBar() {
        this.toastr.success('Notificación', '', { timeOut: this.durationInSeconds * 1000, positionClass: 'toast-top-right' });
    }

}

@Component({
    selector: 'snack-bar-annotated-component-example-snack',
    templateUrl: './snack-bar-annotated-component-example-snack.html',
    styles: [
        `
        :host {
            display: flex;
        }
        .example-pizza-party {
            color: hotpink;
        }
    `,
    ],
})
export class PizzaPartyAnnotatedComponent {
    // Provide an action handler compatible with the template
    onActionClick() {
        // no-op: demo action (used to dismiss in previous implementation)
        return;
    }
}